<template>
  <div id="app">
    <MNotification />
    <OHeader />
    <main>
      <transition
        name="router-anim"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <router-view class="min-height" />
      </transition>
    </main>
    <OFooter />
  </div>
</template>

<script>
import OHeader from "@/components/organisms/o-header.vue";
import OFooter from "@/components/organisms/o-footer.vue";
import MNotification from "@/components/molecules/m-notification.vue";

const BASE_URL = "https://jeffbrasov.ro";

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "DryCleaningOrLaundry",
  name: "Mr Jeff Brașov",
  description:
    "Servicii profesionale de curățătorie și spălătorie cu ridicare și livrare la domiciliu în Brașov.",
  url: BASE_URL,
  telephone: "+40756724674",
  email: "office@luxbrumalis.ro",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Bld. Saturn, Nr. 1C, Zona Gemenii",
    addressLocality: "Brașov",
    addressRegion: "Brașov",
    addressCountry: "RO",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 45.674805,
    longitude: 25.611499,
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "08:00",
      closes: "20:00",
    },
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: "Saturday",
      opens: "09:00",
      closes: "15:00",
    },
  ],
  sameAs: [
    "https://facebook.com/jeffbrasov",
    "https://instagram.com/mrjeff.brasov",
  ],
  image: `${BASE_URL}/og-image.jpg`,
  priceRange: "$$",
  "@id": BASE_URL,
  areaServed: { "@type": "City", name: "Brașov" },
  hasMap: "https://maps.app.goo.gl/KwsoHoibfXgQZg7a6",
  paymentAccepted: ["Cash", "Credit Card"],
  currenciesAccepted: "RON",
  keywords:
    "spălătorie Brașov, spalatorie Brasov, curățătorie Brașov, curatatorie Brasov, curățătorie chimică Brașov, curatatorie chimica Brasov, spălat haine Brașov, spalat haine Brasov, călcat haine Brașov, calcat haine Brasov, curățare haine Brașov, curatare haine Brasov, ridicare livrare rufe Brașov, ridicare livrare rufe Brasov, spălătorie cu livrare la domiciliu Brașov, spalatorie cu livrare la domiciliu Brasov, curățătorie haine lângă mine, curatatorie haine langa mine, dry cleaning Brașov, laundry service Brașov, servicii spălătorie profesională Brașov, igienizare haine Brașov, curățare costume Brașov, curatare costume Brasov, spălat lenjerie hotel Brașov, abonament spălătorie Brașov, abonament spalatorie Brasov, Mr Jeff Brașov, Mr Jeff Brasov",
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "5",
    bestRating: "5",
    worstRating: "1",
    ratingCount: "20",
    reviewCount: "20",
  },
  review: [
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Maria D." },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      name: "Am fost foarte mulțumită!",
      reviewBody:
        "Am apelat la serviciile lor pentru spălat 3 paturi mari. Am fost foarte mulțumită. O să revin și cu alte lucruri la curățat la ei. Au fost prompți și au respectat termenul stabilit la început. Mulțumesc!",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Andrei M." },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      name: "Comunicare excelentă!",
      reviewBody:
        "Salutare! Aveam o plapumă destul de groasă ce stătea prin dulap și acumula praf, astfel că avea nevoie de o curățare urgentă. Am găsit Mr Jeff, am văzut că aveau review-uri bune și zis și făcut. Am lăsat plapuma, iar peste alte două zile era gata, impecabil spălată, iar mirosul cum nu se poate mai fain. Comunicare excelentă, anunțat pe WhatsApp în momentul în care era gata, iar personalul este foarte friendly.",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Elena P." },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      name: "Recomand cu încredere!",
      reviewBody:
        "Recomand cu încredere acestă curățătorie atât pentru personalul de la recepție (care îți explică de la început modul de curățare, riscurile aferente), dar și pentru serviciile oferite (profesionalism, atenție la petele existente pe material, rapiditate).",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Bogdan C." },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      name: "Foarte mulțumit! Recomand cu încredere!",
      reviewBody:
        "Hainele au fost curățate și călcate într-un timp foarte scurt și la un preț avantajos. Au și niște pachete de prețuri foarte bune pentru 6 și pentru 12 cămăși. Program de lucru foarte satisfăcător. Situat la 2 pași de Mall Coresi.",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Radu T." },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      name: "Recomand!",
      reviewBody:
        "Excelentă oferta, serviciile, dar mai ales interacțiunea cu staff-ul. Recomand, sunt bucuros că i-am descoperit!",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Ioana S." },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      name: "Sunt mulțumită de această firmă!",
      reviewBody:
        "Sunt mulțumită de această firmă. Personal foarte amabil și sunt serioși. Pantalonul și sacoul au ieșit super. Mulțumim mult!",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Cristina V." },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      name: "Servicii de calitate!",
      reviewBody:
        "Întotdeauna am avut parte de servicii de calitate aici! Este o doamnă care mi-a oferit consultanță mereu, legată de posibilitatea sau imposibilitatea spălării/îndepărtării unei pete anume sau a unui material anume și am comunicat foarte bine!",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Mihai F." },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      name: "Foarte profesioniști!",
      reviewBody:
        "Foarte profesioniști, calitativi și la prețuri decente, recomand cu drag!",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Ana G." },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      name: "O să revin cu toată încrederea!",
      reviewBody:
        "Am dus o rochie de mireasă la Mr Jeff. Rochia arăta într-un mare fel, mai ales partea de jos. Dar am fost uimită când am luat-o arătând ca nouă! Doamna de acolo foarte ok. O să revin cu toată încrederea!",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Familia P." },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      name: "Recomandăm cu foarte mare drag!",
      reviewBody: "Folosim mereu serviciile! Recomandăm cu foarte mare drag!",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Vlad N." },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      name: "Foarte mulțumit!",
      reviewBody:
        "Foarte mulțumit! Servicii profesioniste de curățare. Personal foarte amabil.",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Corina L." },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      name: "Prețuri avantajoase și punctualitate! Recomand!",
      reviewBody:
        "Prețuri avantajoase și punctualitate! Recomand serviciile Mr Jeff Brașov cu toată încrederea!",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Dan A." },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      name: "Servicii profesioniste!",
      reviewBody: "Servicii profesioniste! Calitate nota 10.",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Laura B." },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      name: "Recomand cu drag!",
      reviewBody: "Recomand cu drag, am fost foarte mulțumită de fiecare dată!",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Simona R." },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      name: "O spălătorie minunată!",
      reviewBody:
        "O spălătorie minunată! Mereu foarte amabili și lucrurile bine curățate! Mulțumim!",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Ionuț K." },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      name: "Experiența a fost super!",
      reviewBody:
        "Experiența a fost super! Am avut nevoie de curățătorie chimică pentru un costum + cămașă și aveam un timp limitat la dispoziție. Totul a fost gata la timp și hainele arătau foarte bine, curate și călcate!",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Gabriela M." },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      name: "Sunteți cei mai tari!",
      reviewBody:
        "Bună dimineața, vreau să îmi spun punctul de vedere pentru această echipă minunată. Sunt mai mult decât mulțumită de toate serviciile! Nu am cuvinte de promptitudine și responsabilitate! Sunteți minunați și nu schimb cu altă curățătorie nici dacă mi le face gratis!",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Teodora H." },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      name: "Mulțumesc Mr Jeff!",
      reviewBody:
        "Mr Jeff este o spălătorie la care o să îmi curăț întotdeauna hainele, bineînțeles dacă își păstrează calitatea. Am rămas frumos surprinsă de atenția cu care mi-au curățat hainele dar și o pilotă, plus comunicarea excelentă cu personalul.",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Alexandru O." },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      name: "Recomand Mr Jeff",
      reviewBody:
        "Calitatea serviciului de curățare - impecabil, efectuat într-un termen mulțumitor de scurt. Termenul a fost respectat și mi s-a amintit prin mesaj că pot merge să ridic piesa lăsată la curățat. Prețul sub media pieței. Recomand Mr Jeff!",
    },
    {
      "@type": "Review",
      author: { "@type": "Person", name: "Nicoleta E." },
      reviewRating: { "@type": "Rating", ratingValue: "5" },
      name: "Adevărați profesioniști!",
      reviewBody:
        "Adevărați profesioniști! Îți expun riscurile la predarea hainelor pentru curățat și se încadrează în termenul menționat pentru predarea hainelor curate. Servicii de curățare de calitate. Recomand!",
    },
  ],
};

const webSiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Mr Jeff Brașov",
  url: BASE_URL,
  inLanguage: ["ro", "en"],
  description:
    "Servicii profesionale de curățătorie chimică, spălătorie și călcătorie haine în Brașov. Ridicare și livrare la domiciliu. Pachete, abonamente și prețuri accesibile.",
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: `${BASE_URL}/ro/servicii-preturi?q={search_term_string}`,
    },
    "query-input": "required name=search_term_string",
  },
};

export default {
  name: "MrJeff",
  metaInfo() {
    return {
      htmlAttrs: { lang: this.$i18n.locale },
      title: this.$t("Bine ai venit!"),
      titleTemplate: "%s | Mr Jeff Brașov",
      meta: [
        { name: "robots", content: "index, follow" },
        { name: "author", content: "Mr Jeff Brașov" },
        { property: "og:site_name", content: "Mr Jeff Brașov" },
        { property: "og:type", content: "website" },
        { property: "og:image", content: `${BASE_URL}/og-image.jpg` },
        { property: "og:image:width", content: "1200" },
        { property: "og:image:height", content: "630" },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:image", content: `${BASE_URL}/og-image.jpg` },
      ],
      script: [
        {
          type: "application/ld+json",
          json: localBusinessSchema,
        },
        {
          type: "application/ld+json",
          json: webSiteSchema,
        },
      ],
    };
  },
  components: {
    OHeader,
    OFooter,
    MNotification,
  },
};
</script>

<style lang="scss">
@import "~@storefront-ui/shared/styles/helpers/breakpoints";

body {
  margin: 0;
  font-family: var(--font-family-secondary);
  padding-top: var(--h-header);
  background-color: var(--c-light);
}
#app {
  --h-header: 142px;
  --h-footer: 112px;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  ::selection {
    color: var(--c-white);
    background: var(--c-primary-darken);
  }
}
.min-height {
  min-height: calc(100vh - var(--h-footer) - var(--h-header));
}
.container {
  position: relative;
  max-width: 1250px;
  width: 100%;
  margin: 0 auto;
  padding: 0 var(--spacer-sm);

  @include for-mobile {
    padding: 0;
  }
}
</style>
